import { Routes } from '@angular/router';
import { AmplifyAuthGuardService } from 'src/app/core/guards/amplify-auth-guard.service';
import { OktaAuthGuardService } from 'src/app/core/guards/okta-auth-guard.service';
import { OktaLoginComponent } from 'src/app/features/auth/okta-login/okta-login.component';
import { OktaRedirectComponent } from 'src/app/features/auth/okta-redirect/okta-redirect.component';
import { SignoutComponent } from 'src/app/features/auth/signout/signout.component';
import { CampaignAnalyticsComponent } from 'src/app/features/campaigns/campaign-analytics/campaign-analytics.component';
import { CampaignDeliveriesComponent } from 'src/app/features/campaigns/campaign-analytics/campaign-deliveries/campaign-deliveries.component';
import { CampaignsComponent } from 'src/app/features/campaigns/campaign-table/campaigns.component';
import { ModalContainerCampaignComponent } from 'src/app/features/campaigns/campaign-table/view-campaign/modal-container/modal-container.component';
import { ContentComponent } from 'src/app/features/content/content-table/content.component';
import { DrbDiffComponent } from 'src/app/features/drbs/drb-diff/drb-diff.component';
import { DrbSourcesComponent } from 'src/app/features/drbs/drb-sources/drb-sources.component';
import { ViewDrbComponent } from 'src/app/features/drbs/view-drb/view-drb.component';
import { InsightsComponent } from 'src/app/features/insights/insights-table/insights.component';
import { ModalContainerInsightComponent } from 'src/app/features/insights/insights-table/view-insight/modal-container/modal-container.component';
import { CreateCleanScoreComponent } from 'src/app/features/qa-testing/clean-score/create-clean-score/create-clean-score.component';
import { ViewCleanScoreComponent } from 'src/app/features/qa-testing/clean-score/view-clean-score/view-clean-score.component';
import { CleanTimeEstimatesComponent } from 'src/app/features/qa-testing/clean-time-estimates/clean-time-estimates.component';
import { MyRobotsComponent } from 'src/app/features/qa-testing/my-robots/my-robots.component';
import { QaTestingComponent } from 'src/app/features/qa-testing/qa-tool/qa-testing.component';
import { RobotPartHealthComponent } from 'src/app/features/qa-testing/robot-part-health/robot-part-health.component';
import { QuickStartComponent } from 'src/app/features/quick-start/quick-start.component';
import { RobotFamilyMetadataComponent } from 'src/app/features/robot-family-metadata/robot-family-metadata-table/robot-family-metadata.component';
import { SurveysComponent } from 'src/app/features/surveys/surveys-table/surveys.component';

const QA_ROUTES: Routes = [
  {
    path: 'qa-testing/clean-score/create',
    component: CreateCleanScoreComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/clean-score/view',
    component: ViewCleanScoreComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/qa-tool',
    component: QaTestingComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/my-robots',
    component: MyRobotsComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/cleaning-estimates',
    component: CleanTimeEstimatesComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/robot-part-health',
    component: RobotPartHealthComponent,
    canActivate: [OktaAuthGuardService]
  }
];

const CAMPAIGN_ROUTES: Routes = [
  {
    path: 'campaigns/table',
    component: CampaignsComponent,
    children: [{ path: ':id', component: ModalContainerCampaignComponent }]
  },
  {
    path: 'campaigns/analytics',
    component: CampaignAnalyticsComponent,
    children: [{ path: 'deliveries', component: CampaignDeliveriesComponent }]
  }
];

const INSIGHT_ROUTES: Routes = [
  {
    path: 'insights',
    canActivate: [AmplifyAuthGuardService],
    children: [
      { path: 'view/:id', component: ModalContainerInsightComponent },
      {
        path: 'active',
        pathMatch: 'full',
        component: InsightsComponent,
        canActivate: [AmplifyAuthGuardService]
      },
      {
        path: 'inactive',
        pathMatch: 'full',
        component: InsightsComponent,
        canActivate: [AmplifyAuthGuardService]
      }
    ]
  }
];

const DRB_ROUTES: Routes = [
  {
    path: 'drb/:bundle_name/view',
    component: ViewDrbComponent,
    canActivate: [AmplifyAuthGuardService]
  },
  {
    path: 'drb/:bundle_name/create',
    component: DrbSourcesComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'drb/:bundle_name/deploy',
    pathMatch: 'full',
    component: DrbDiffComponent,
    canActivate: [OktaAuthGuardService]
  }
];

const CONTENT_ROUTES: Routes = [
  {
    path: 'content/table',
    component: ContentComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

const RFM_ROUTES: Routes = [
  {
    path: 'robot-family-metadata/table',
    component: RobotFamilyMetadataComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

const SURVEY_ROUTES: Routes = [
  {
    path: 'surveys',
    component: SurveysComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

const QUICKSTART_ROUTES: Routes = [
  {
    path: 'quick-start',
    component: QuickStartComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

const AUTH_ROUTES: Routes = [
  { path: 'login', component: OktaLoginComponent },
  { path: 'redirect', component: OktaRedirectComponent },
  { path: 'signout', component: SignoutComponent }
];

export const ROUTES: Routes = [
  ...AUTH_ROUTES,
  ...QA_ROUTES,
  ...CAMPAIGN_ROUTES,
  ...INSIGHT_ROUTES,
  ...DRB_ROUTES,
  ...CONTENT_ROUTES,
  ...RFM_ROUTES,
  ...SURVEY_ROUTES,
  ...QUICKSTART_ROUTES
];
